import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=2deb3552&scoped=true"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=2deb3552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb3552",
  null
  
)

export default component.exports